import React, { lazy, useState, useEffect } from 'react';
import { Route, Switch, useLocation, Redirect } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify';
import MainLayout from './../layout/MainLayout';
import Services from '../services/index';
import Loader from '../ui-component/extended/Loader/Loader';
import allActions from '../store/redux-actions/index'

import QuyenTruyCapModal from '../views/default/QuyenTruyCapModal';
import DoiMatKhauModal from '../views/default/DoiMatKhauModal';
import CapNhatTaiKhoanModal from '../views/default/CapNhatTaiKhoanModal';
const ThongKeThiPhanPage = lazy(() => import( '../views/thongke-thiphan-page'));
const ThongKeDonViPage  = lazy(() => import('../views/thongke-diaban-page'));
const LichSuPage = lazy(() => import( '../views/lichsu-page'));
const DashboardDefault = lazy(() => import('../views/dashboard/Default'));

const TableBasic = lazy(() => import('../views/forms/tables/TableBasic'));
const TableDense = lazy(() => import('../views/forms/tables/TableDense'));

const UtilsTypography = lazy(() => import('../views/utilities/typography'));
const UtilsColor = lazy(() => import('../views/utilities/color'));
const UtilsShadow = lazy(() => import('../views/utilities/shadow'));
const UtilsMaterialIcons = lazy(() => import('../views/utilities/icons/MaterialIcons'));
const UtilsTablerIcons = lazy(() => import('../views/utilities/icons/TablerIcons'));


const DonViPage = lazy(() => import('../views/donvi-page'));
const TrungTamPage = lazy(() => import('../views/trungtam-page'));
const nhanvienPage = lazy(() => import('../views/nhanvien-page'));
const HopDongPage = lazy(() => import('../views/hopdong-page'));
const DVHCPage = lazy(() => import('../views/dvhc-page'));
const KhachHangPage = lazy(() => import('../views/khachhang-page'));
const DichVuPage = lazy(() => import('../views/dichvu-page'));
const DeXuatPage = lazy(() => import('../views/dexuat-page'));
const ThongKeKhachHangPage = lazy(() => import('../views/thongke-khachhang-page'));
const MainRoutes = () => {
    const location = useLocation();
    const [roleUser, setRoleUser] = useState(["LOADING"]);
    const displayModal = useSelector(state => state.displayModal)
    const [userID, setUserID] = useState();
    const dispatch = useDispatch()
    const [banThan, setBanThan] = useState({
        "_id": "",
        "hoTen": "",
        "anhDaiDien": "",
        "gioiTinh": "",
        "diaChi": "",
        "soCMND": "",
        "soDienThoai": "",
        "matKhau": "",

    });
    var isMounted = true;
    useEffect(() => {
        isMounted = true;
        Services.getTaiKhoanService().xacThuc().then(
            (response) => {

                if (response.data != null) {
                    setRoleUser(response.data.roles);
                    // console.log(response.data.roles);
                    setUserID(response.data.userID)
                    Services.getQuyenTruyCapService().checkAll(response.data.roles).then(
                        (response2) => {
                            if (response2.data != null) {
                                
                                dispatch(allActions.quyenTruyCapActions.setQuyen(response2.data))
                                dispatch(allActions.roleActions.setRole(response.data.roles))
                      
                            }
                        },
                        (error) => {
                        }
                    );
                    Services.getTaiKhoanService().getBanThan().then(
                        (response) => {
                            if (response.data != null) {
                                setBanThan(response.data)
                                dispatch(allActions.nguoiDungActions.setNguoiDung(response.data))
                            }
                        },
                        (error) => {
                        }
                    );
                }
            },
            (error) => {
                // window.location="/logout"
            }
        );

        return () => { isMounted = false };
    }, []);
    return (
        < >   
            {roleUser.includes("LOADING") && <Loader />}
            {!roleUser.includes("LOADING") ?
                <>
                    <ToastContainer />

                    {displayModal?.type=="QuyenTruyCap"?<QuyenTruyCapModal roleConfig={displayModal?.value}/>:null}
                    {displayModal?.type=="DoiMatKhau"?<DoiMatKhauModal nhanVienUp={banThan}/>:null}
                    {displayModal?.type=="CapNhatUser"?<CapNhatTaiKhoanModal nhanVienUp={banThan}/>:null}
                    <MainLayout showBreadcrumb={true}>

                        <Switch location={location} key={location.pathname}>


                            <Route exact path="/home/dashboard/default" component={DashboardDefault} />
                            <Route exact path="/home/donvi" component={DonViPage} />
                            <Route exact path='/home/nhanvien' component={nhanvienPage} />
                            <Route exact path='/home/hopdong' component={HopDongPage} />
                            <Route exact path='/home/dvhc' component={DVHCPage} />
                            <Route exact path='/home/khachhang' component={KhachHangPage} />
                            <Route exact path='/home/dichvu' component={DichVuPage} />
                            <Route exact path='/home/dexuat' component={DeXuatPage} />
                            <Route exact path="/home/statistic/customer" component={ThongKeKhachHangPage} />
                            <Route exact path="/home/statistic/unit" component={ThongKeDonViPage} />
                            <Route exact path="/home/statistic/marketshare" component={ThongKeThiPhanPage} />
                            <Route exact path="/home/history/all" component={LichSuPage} />
                            {/* <Route exact path="/home/trungtam" component={TrungTamPage} /> */}
                            {/* <Route path="/home/*" component={NotFoundPage} /> */}
                        </Switch>
                    </MainLayout>
                </>
                : <></>}
        </>
    );
};

export default MainRoutes;
